import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import Loading from "../loading/loading";
import Icon from '@material-ui/core/Icon';
import { withStyles } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import Typography from '@material-ui/core/Typography';
import RenderDateField from "../inputs/renderDateField";

const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  icon: {
    margin: theme.spacing.unit * 2,
  },
  iconHover: {
    margin: theme.spacing.unit * 2,
    '&:hover': {
      color: red[800],
    },
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: "flex-end",
    '@media (max-width: 780px)' : {
      flexDirection: 'column',
      alignItems: "center"
    }
  },
  formControl: {
    margin: theme.spacing.unit,
  },
  item: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    '@media (max-width: 780px)' : {
      margin: theme.spacing.unit,
    }
  }
});

const StoresUpdateForm =  (props) =>{
  const {updateStores, handleSubmit, handleCancel, patchingCollection, classes} = props;
  return (
    <React.Fragment>
      <Loading displayLoader={patchingCollection}/>
      <form id={"updateStoresCollection"} onSubmit={handleSubmit(updateStores)} className={classes.container}>
        <Typography variant="subtitle2" className={classes.item}>
          Εξαμηνιαία
        </Typography>
        <Icon className={`${classes.item} fas fa-less-than`} />
        <Field
          name="startDate"
          label={'Start Date'}
          component={RenderDateField}
          type="date"
          required
          fullwidth
          classes={{root: classes.item}}
        />
        <Icon className={`${classes.item} fas fa-less-than-equal`} />
        <Typography variant="subtitle2"  className={classes.item}>
          Εξαμηνιαία & Νέα
        </Typography>
        <Icon className={`${classes.item} fas fa-less-than-equal`} />
        <Field
          name="endDate"
          label={'End Date'}
          component={RenderDateField}
          type="date"
          required
          fullwidth
          classes={{root: classes.item}}
        />
        <Icon className={`${classes.item} fas fa-less-than`} />
        <Typography variant="subtitle2" className={classes.item}>
          Νέα
        </Typography>
      </form>
    </React.Fragment>
  )

};

export default reduxForm({
  form: 'storesUpdateForm',
})(withStyles(styles)(StoresUpdateForm));



// WEBPACK FOOTER //
// ./src/components/stores/storesUpdateForm.js